/* Actions */
import { ACTION_TYPES_BASE_NAME } from "./actions";
import { actionTypes as pdpActionTypes } from "../actions";

/* Others */
import { makeFetchReducers } from "../../../utils";

const reducers = makeFetchReducers(ACTION_TYPES_BASE_NAME, null, {
  accumulateResults: true,
  additionalResetAction: pdpActionTypes.RESET
});

export default reducers;
